<button *ngFor="let menu of menus; trackBy: trackByMenu" mat-menu-item (click)="clickAction.emit(menu)">
  <mat-icon
    *ngIf="!menu.isSvg; else svgIcon"
    class="b3n-text-icon"
    [ngClass]="menu.size ? 's-' + menu.size : ''"
    [ngClass]="menu.classIcon"
  >
    {{ menu.icon }}
  </mat-icon>
  <ng-template #svgIcon>
    <mat-icon
      class="b3n-text-icon"
      [ngClass]="menu.size ? 's-' + menu.size : ''"
      [ngClass]="menu.classIcon"
      [svgIcon]="menu.icon"
    ></mat-icon>
  </ng-template>
  <span [ngClass]="menu.classText">{{ menu.value }}</span>
</button>
